import moment from "moment";

export const decodeTime = (timeValue, locale = 'ru') => {
    moment.locale(locale);

    const time = moment(timeValue, "HH:mm:ss").format("HH:mm");

    return time;
};